import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';
import { Outlet } from 'react-router';
import NavigationHeader from './NavigationHeader';

const HeaderWrapper = styled.div`
  background-color: ${colors.bigBangBlack};
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div`
  flex: 1;
  background-color: ${colors.neutral5};
`;

const NavigationHeaderWrapper = () => (
  <HeaderWrapper>
    <NavigationHeader />
    <MainContent>
      <Outlet />
    </MainContent>
  </HeaderWrapper>
);

export default NavigationHeaderWrapper;
